module.exports = "/_next/static/images/10-d072bcc9f0dada00330a971c06ce515e.png.webp";